<template>
  <div v-if="operationDiverse">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detailOperationDiverse.title') }}
                {{ operationDiverse.mouvementOd.libelle }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">

          <dropdownButton
            type="is-addOrEdit"
            class="mgr-2"
            :permission="permOperationDiverse.maj"
            :actions="actionSecondary"
            :disabled="operationDiverse.etat === constantes.VALIDE"
            @click="() => {
              $router.push({ name: 'm.comptabilite.operation_diverse-edit',
               params: { id: operationDiverse.id }});
            }">
              {{ $t('general.button.edit') }}
          </dropdownButton>

            <button class="button is-addOrEdit" v-if="operationDiverse.etat !== constantes.VALIDE"
                    :class="{'button-access-no-permission' :
                    !checkPermissions(permOperationDiverse.maj)}"
                    @click="
               checkPermissions(permOperationDiverse.maj)
               ? OpenPopUpEtatOperationDiverse() : showPopUp()">
               {{ $t('detailOperationDiverse.actions.validation') }}
            </button>
            <button class="button">
              <b-dropdown position="is-bottom-left" aria-role="list">
                <a slot="trigger">
                  <b-icon
                    type="is-default"
                    icon="dots-vertical">
                  </b-icon>
                </a>
                <b-dropdown-item class="has-text-left"
                  @click="checkPermissions(permOperationDiverse.maj) ?
                  generateEcritureComptable() : showPopUp()">
                  {{ $t('detailOperationDiverse.actions.generateEcriture') }}
                </b-dropdown-item>
              </b-dropdown>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="steps-detail mgt-20px" v-if="curentStep">
      <dot-steps :steps="dataStep"
                  :current-step="curentStep"
                  :racineTraduction="''"/>
    </div>
    <div class="mgt-20px">
      <div class="tab">
        <ul>
          <li @click="activeTab = 'detailOperationDiverse'"
              :class="{'is-active': activeTab === 'detailOperationDiverse'}">
              {{ $t('detailOperationDiverse.onglet.operationDiverse')}}
          </li>
          <li @click="activeTab = 'ecrituresComptaDetail'"
              v-if="operationDiverse.exportOdComptabilite"
              :class="{'is-active': activeTab === 'ecrituresComptaDetail'}">
            {{ $t('detailOperationDiverse.onglet.ecritureCompta')}}
          </li>
        </ul>
      </div>
      <div>
        <component v-if="operationDiverse"
                  :is="activeTab"
                  :operation-diverse="operationDiverse"
                  :dateDernierExport="operationDiverse.dernierExportComptable"
                  :ecritures="ecritures"/>
      </div>
    </div>
    <b-modal v-model="popUpEtatOperationDiverse" has-modal-card class="modal">
      <pop-up-prevention  :messHeader="$t('detailOperationDiverse.validation.title')"
                              :cancel="$t('general.non')"
                              :validate="$t('general.oui')"
                              :isErrorPopup.sync="isErrorPopup"
                              :messagesPopup="messagesErrorPopUp"
                              @no="popUpEtatOperationDiverse = false"
                              @yes="validationOD()">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('detailOperationDiverse.popUpSuppression.title')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :isErrorPopup.sync="isErrorPopup"
        :messagesPopup="messagesErrorPopUp"
        @no="popUpSuppression = false"
        @yes="deleteOd"/>
    </b-modal>
  </div>
</template>
<script>

import breadcrumb from '@/components/general/breadcrumb';
import dropdownButton from '@/components/general/button/dropdownButton';
import { get, deleteOd, valide } from '@/api/compta/operationDiverse/index';
import messageErreur from '@/services/general/messageErreur';
import { createNamespacedHelpers } from 'vuex';
import { OPERATION_DIVERSE } from '@/configuration/compta/permissionsComptaConf';
import { generateByOperationDiverse, getByOperationDiverse } from '@/api/compta/ifEcriture';
import { TYPE_OD } from '@/configuration/compta/ecritureConf';
import messageSucces from '@/services/general/messageSucces';
import detailOperationDiverse from '@/components/compta/operationDiverse/detailOperationDiverse';
import ecrituresComptaDetail from '@/components/commun/ecritureComptable/ecrituresComptaDetail';
import { LISTE_ETAT_OD, VALIDE } from '@/configuration/compta/odConfig';
import DotSteps from '@/components/general/dotSteps';
import popUpPrevention from '@/components/general/popUpPrevention';
import validation from '@/services/compta/operationDiverse/validation/validation';
import messageInformation from '@/services/general/messageInformation';
import { NON_LETTRE } from '@/configuration/lettrageConf';

const permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      operationDiverse: null,
      permOperationDiverse: OPERATION_DIVERSE,
      activeTab: 'detailOperationDiverse',
      listeEtat: LISTE_ETAT_OD,
      constantes: {
        VALIDE,
        NON_LETTRE,
      },
      popUpEtatOperationDiverse: false,
      isErrorPopup: false,
      messagesErrorPopUp: [],
      popUpSuppression: false,
      ecritures: [],
    };
  },
  components: {
    dropdownButton,
    appBreadcrumb: breadcrumb,
    detailOperationDiverse,
    ecrituresComptaDetail,
    DotSteps,
    popUpPrevention,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    breadcrumb() {
      const output = [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeOperationDiverse.title'), route: { name: 'l.comptabilite.operation_diverse' }, isActive: false },
        { title: this.$t('detailOperationDiverse.title'), isActive: true },
      ];
      return output;
    },
    totalCredit() {
      let total = 0;
      total += this.operationDiverse.mouvementOd?.credit || 0;
      total += this.operationDiverse.lignesOd
        .map(f => f.credit)
        .reduce((a, b) => a + b, 0);
      return total;
    },
    totalDebit() {
      let total = 0;
      total += this.operationDiverse.mouvementOd?.debit || 0;
      total += this.operationDiverse.lignesOd
        .map(f => f.debit)
        .reduce((a, b) => a + b, 0);
      return total;
    },
    dataStep() {
      return this.listeEtat.map(el => el.libelle);
    },
    curentStep() {
      const index = this.listeEtat.map(el => el.value).indexOf(this.operationDiverse.etat);
      return this.dataStep[index];
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t('general.button.delete'),
          action: () => { this.popUpSuppression = true; },
          permissionAction: OPERATION_DIVERSE.supprimer,
          disabled: this.operationDiverse.mouvementOd.etatLettrage !== this.constantes.NON_LETTRE
            || this.operationDiverse.etat === this.constantes.VALIDE,
        },
      ];

      return actions;
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async generateEcritureComptable() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await generateByOperationDiverse({
          referencePieceId: this.operationDiverse.id,
          typeEcriture: TYPE_OD,
        });
        this.ecritures = (await getByOperationDiverse(this.operationDiverse.id)).data.result;
        messageSucces(this.$t('detailOperationDiverse.messages.successGenerateEcriture'));
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
    async validationOD() {
      this.isErrorPopup = false;
      this.messagesErrorPopUp = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        await valide(this.$route.params.id);
        messageSucces(this.$t('detailOperationDiverse.messages.successValidation'));
        this.popUpEtatOperationDiverse = false;
        this.operationDiverse = (await get(this.$route.params.id)).data.result;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response && e.response.data.error) {
          validation(e.response, this.messagesErrorPopUp);
          this.isErrorPopup = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      }
    },
    noValidatation() {
      messageInformation(this.$i18n.t('detailOperationDiverse.messages.noValidation'), 'is-primary');
    },
    OpenPopUpEtatOperationDiverse() {
      if (this.operationDiverse.exportOdComptabilite) this.popUpEtatOperationDiverse = true;
      else this.noValidatation();
    },
    async deleteOd() {
      this.isErrorPopup = false;
      this.messagesErrorPopUp = [];

      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteOd(this.operationDiverse.id);
        messageSucces(this.$t('detailOperationDiverse.messages.successSuppression'));
        this.popUpSuppression = false;
        loadingComponent.close();
        this.$router.push({ name: 'l.comptabilite.operation_diverse' });
      } catch (e) {
        loadingComponent.close();
        if (e.response && e.response.data.error) {
          validation(e.response, this.messagesErrorPopUp);
          this.isErrorPopup = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const operationDiverse = (await get(this.$route.params.id)).data.result;
      this.operationDiverse = operationDiverse;
      this.ecritures = (await getByOperationDiverse(this.operationDiverse.id)).data.result;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.operationDiverse.mouvementOd.libelle }));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
